<div class="item d-flex" (click)="openRequest()">
    <div class="avatar m-2">
        <one-avatar [imageUrl]="request.submitterInfo.avatar" [size]="36"></one-avatar>
    </div>
    <div class="info m-2 flex-grow-1">
        <div class="title">{{request.name}}</div>
        <div class="description">Nhóm: {{request.requestGroupName}} - Tạo ngày: {{request.submitDate}}</div>
    </div>
    <div class="approval-status m-2">
        <mat-chip-list>
            <mat-chip [class]="request.status" selected>{{request.friendlyStatus}}</mat-chip>
        </mat-chip-list>
    </div>
</div>